export const UsersEndpoints = {
  find: () => {
    return '/v1/users/search'
  }
}
